import "./common.scss";

export const UnfollowButton = (props: {
  onClick: () => void;
}): JSX.Element => {
  return (
    <button
      className="rg-button unfollow small"
      onClick={props.onClick}
    >Unfollow</button>
  );
};
